import React from "react";
import { useState, useEffect } from "react";
import format from "date-fns/format";
import Chart from "react-apexcharts";
import { getTimeChartDashboardApi } from "../../../services/DashboardService";
import DatePicker from "react-datepicker";
import { toast } from "react-toastify";
const TimeChart = ({ selectedServicecenter }) => {
  const [data, setData] = useState([]);
  const [param, setParam] = useState({
    start_date: format(new Date(), "yyyy-MM-dd"),
    end_date: format(new Date(), "yyyy-MM-dd"),
  });
  const getTimeData = () => {
    getTimeChartDashboardApi(
      selectedServicecenter == "all" ? "" : selectedServicecenter,
      param
    )
      .then((res) => {
        const timeData = res.data.results?.map((item) => ({
          time_interval: item?.time_interval || "",
          billings_count: item?.billings_count || "",
        }));
        setData(timeData);
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      });
  };
  useEffect(() => {
    if (selectedServicecenter) {
      getTimeData();
    }
  }, [selectedServicecenter, param]);
  const series = [
    {
      name: "Billing Count",
      data:data?.map((item)=>Number(item?.billings_count))||[],
    },
  ];
  const options = {
    chart: {
      type: "bar",
      toolbar: { show: false },
    },
    plotOptions: {
      bar: {
        borderRadius: 5,
        columnWidth: "50%",
        distributed: true,
      },
    },
    colors: ["#7f0000", "#b71c1c", "#c62828", "#d32f2f", "#e53935", "#f44336"],
    dataLabels: {
      enabled: false,
    },
    legend: {
      show: false,
    },
    xaxis: {
      categories:
        data?.map((item) =>
          item?.time_interval?.length > 4
            ? item.time_interval.slice(0, 4) + "..."
            : item.time_interval
        ) || [],

      labels: {
        style: {
          fontSize: "13px",
          fontWeight: 500,
        },
      },
    },
    yaxis: {
      labels: {
        style: {
          fontSize: "12px",
        },
      },
    },
    grid: {
      borderColor: "#f1f1f1",
    },
    tooltip: {
      enabled: true,
      shared: false,
      intersect: true,
      custom: function ({ dataPointIndex }) {
        const fullLabel = data?.[dataPointIndex]?.time_interval || "";
        const billingCount = data?.[dataPointIndex]?.billings_count || 0;

        return `
      <div style="
        background: #fff;
        color: #333;
        padding: 8px 12px;
        border-radius: 8px;
        box-shadow: 0 2px 8px rgba(0,0,0,0.15);
        font-size: 13px;
        line-height: 1.5;
        min-width: 140px;
      ">
        <div style="font-weight:600; font-size:14px; margin-bottom:4px; color:#2a3f54;">
          ${fullLabel}
        </div>
        <div style="font-size:13px; color:#555;">
          Billing Count: <span style="font-weight:600; color:#111;">${billingCount}</span>
        </div>
      </div>
    `;
      },
    },
  };

  return (
    <div className="card p-2 pb-0 border-0 shadow-sm rounded-3 h-100">
      <div className="mb-2 px-1 d-flex justify-content-between align-items-center gap-1">
        <h5 className="mb-0">Billing</h5>
        <div className="">
          <style>
            {`
              .react-datepicker__input-container input {
                font-size: 0.65rem !important;
                height:31px !important;
              }
                   .react-datepicker__close-icon::after {
                font-size: 9px !important;
                line-height: 9px !important;
                width: 13px !important;
                height: 9px !important;
              }
            `}
          </style>
          <DatePicker
            selectsRange
            startDate={param?.start_date ? new Date(param.start_date) : null}
            endDate={param?.end_date ? new Date(param.end_date) : null}
            onChange={(update) => {
              const [start, end] = update;
              setParam((prev) => ({
                ...prev,
                start_date: start ? format(start, "yyyy-MM-dd") : "",
                end_date: end ? format(end, "yyyy-MM-dd") : "",
              }));
            }}
            isClearable
            placeholderText="Select date range"
            className="form-control"
          />
        </div>
      </div>
      <div>
        <Chart options={options} series={series} type="bar" height={280} />
      </div>
    </div>
  );
};

export default TimeChart;
